import { useEffect } from "react";

import { useUiStore } from "@/store/ui";

const TOAST_TTL_MS = 3600;

/**
 * 原型基元：`.toast-region` + `.toast`。
 * 区域本身 `aria-live="polite"`；单条 toast 到期自动消失。
 */
export function ToastRegion() {
  const toasts = useUiStore((state) => state.toasts);
  const dismissToast = useUiStore((state) => state.dismissToast);

  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((toast) =>
      window.setTimeout(() => dismissToast(toast.id), TOAST_TTL_MS),
    );
    return () => timers.forEach((timer) => window.clearTimeout(timer));
  }, [toasts, dismissToast]);

  return (
    <div className="toast-region" id="toast-region" aria-live="polite">
      {toasts.map((toast) => (
        <div className="toast" key={toast.id}>
          <span aria-hidden="true">{toast.mark}</span>
          <div>
            <strong>{toast.title}</strong>
            <small>{toast.detail}</small>
          </div>
        </div>
      ))}
    </div>
  );
}
